module.exports = __webpack_public_path__ + "static/media/joyable1_preview.9d2e2dab.jpg";